"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
exports.SUMMARY_PAGES_NAVIGATION_PREFIX = new core_1.InjectionToken('Summary pages base path prefix.');
//# sourceMappingURL=summary-pages-navigation-prefix.js.map